<template>
  <!-- BEGIN: Modal Content -->
  <Dialog
    :open="warningModalPreview"
    @close="hideModal()"
  >
    <Dialog.Panel>
                <div class="p-5 text-center">
                  <Lucide
                    icon="XCircle"
                    class="w-16 h-16 mx-auto mt-3 text-warning"
                  />
                  <div class="mt-5 text-3xl">Oops...</div>
                  <div class="mt-2 text-slate-500">Something went wrong!</div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <Button
                    type="button"
                    variant="primary"
          @click="warningModalPreview = false"
          class="w-24"
        >
          Ok
        </Button>
      </div>
      <div
        class="p-5 text-center border-t border-slate-200/60 dark:border-darkmode-400"
      >
        <a href="" class="text-primary">Why do I have this issue?</a>
      </div>
    </Dialog.Panel>
    </Dialog>
  <!-- END: Modal Content -->
</template>

<script setup>
  import { ref, watch, computed } from "vue";
  import { useStore } from "vuex";
  import { Dialog } from "@/base-components/Headless";
  import  Button  from "@/base-components/Button";
  import  Lucide  from "@/base-components/Lucide";
  // const basicModalPreview = ref(false);
  const warningModalPreview = ref(false);
  const store = useStore();

  warningModalPreview.value = store.state.showWarningModal;

  const hideModal = () => {
    store.commit('showWarningModal', false);
  }

  watch(
    computed(() => store.state.showWarningModal),
    () => {
      if(store.state.showWarningModal) {
        warningModalPreview.value = store.state.showWarningModal;
      }
    }
  );
</script>
